<template>
  <div>
    <div class="back" @click="back(false)">
      <img src="@/assets/icons/icon_fh.png" alt="" srcset="">
      <span>{{ $t('admin.sensitive.add.back') }}</span>
    </div>
    <h4>{{ id ? $t('admin.sensitive.add.edit') : $t('admin.sensitive.add.create') }}</h4>
    <a-form :form="form" layout="vertical">
<!--      <div class="title"> 基本信息 </div>-->
      <div class="list" style="padding-top: 20px;">
        <a-form-item class="full" :label="$t('admin.sensitive.add.form.word.label')" :colon="false">
          <a-textarea
            :placeholder="$t('admin.sensitive.add.form.word.placeholder')"
            v-decorator="['words', { rules: [{ required: true, message: $t('admin.sensitive.add.form.word.required') }] }]" ></a-textarea>
        </a-form-item>
      </div>
      <div class="submit-button">
        <a-button type="primary" @click="handleSubmit">{{ $t('admin.sensitive.add.submit') }}</a-button>
      </div>
    </a-form>

  </div>
</template>

<script>
import cookie from 'js-cookie'

import {
  getSensitiveWordsDetail,
  getTrainingEquipmentDetail,
  postSensitiveWordsSave
} from '@/api/admin'

export default {
  data() {
    return {
      id: undefined,
      form: this.$form.createForm(this),
      roomList:[],
      txtContent: null,
    }
  },
  methods: {

    back() {
      // this.$router.push({
      //   name: 'teacherList'
      // })
      this.$router.go(-1);
    },
    handleSubmit(e) {
      e.preventDefault()
      this.form.validateFields((err, values) => {
        if (!err) {
          console.log(values)
          if( this.id){
            values.id=this.id
          }
          postSensitiveWordsSave(values).then(res => {
            if (res.code == 200) {
              const successMsg = this.id 
                ? this.$t('admin.sensitive.add.success.edit')
                : this.$t('admin.sensitive.add.success.create')
              this.$message.success(successMsg)
              this.$router.go(-1);
            }
          })
        }
      })
    },
    getSensitiveWordsDetailHttp() {
      getSensitiveWordsDetail({ id: this.id }).then(res => {
        if (res.code == 200) {
          console.log(res.data)
          this.form.setFieldsValue({
            words: res.data.words,
          })
        }
      })
    },


  },
  mounted() {
    this.id = this.$route.query.id || undefined
    if (this.id) {
      this.getSensitiveWordsDetailHttp()
    }
  }
}
</script>

<style lang="less" scoped>
h4{
  font-size: 16px;
  font-weight: 800;
  color: #000000;
  border-bottom: 1px solid #EDEDED;
  padding-bottom: 20px;
}
.admin{
  width: 100%;
  cursor: pointer;
  text-align: right;
  margin-bottom: 21px;
  .user-logo{
    width: 26px;
    height: 26px;
    border-radius: 100%;
    margin-right: 12px;
  }
  .down{
    width: 10px;
    margin-left: 5px;
  }
}
/deep/.ant-input-suffix{
  right: 12px;
  img{
    width: 23px;
    cursor: pointer;
  }
}
.back{
  width: 80px;
  height: 34px;
  display: flex;
  cursor: pointer;
  font-size: 14px;
  font-weight: 400;
  color: #000000;
  border-radius: 25px;
  margin-top: 16px;
  margin-bottom: 26px;
  align-items: center;
  justify-content: center;
  border: 1px solid #D6D6D6;
  img{
    height: 10px;
    margin-right: 9px;
  }
}
/deep/.ant-form{
  .title{
    display: flex;
    font-size: 14px;
    font-weight: 600;
    color: #627587;
    line-height: 20px;
    position: relative;
    padding: 12px 17px;
    margin-bottom: 30px;
    align-items: center;
    border-bottom: 1px solid #EDEDED;
    &::before{
      left: 0;
      content: '';
      width: 4px;
      height: 12px;
      border-radius: 2px;
      position: absolute;
      background: #6B738C;
    }
  }
  .list{
    display: flex;
    //padding-right: 200px;
    .ant-form-item-label{
      min-width: 64px;
    }
    .ant-form-item-label label{
      color: #000000;

    }
    .ant-form-item{
      width: 100%;
      // display: flex;
      //padding-left: 45px;
      //&:first-child{
      //  padding-left: 0;
      //  padding-right: 45px;
      //}
      .ant-form-item-control-wrapper{
        width: 100%;
      }
    }
    .ant-input-affix-wrapper .ant-input-suffix{
      position: absolute;
      img{
        width: 23px;
        height: 23px;
      }
    }
    .ant-calendar-picker div{
      position: relative;
      .ant-calendar-picker-input{
        width: 228px;
        height: 35px;
        margin-right: 0;
        color: #000000;
        border-radius: 4px;
        background: #FFFFFF;
        border: 1px solid #D8DCE0;
      }

    }
    .ant-input,
    .ant-select{
      height: 500px !important;
      //border-radius: 20px;
      color: #000000;
    }
    .full .ant-input,
    .full .ant-select{
      width: 100%;
      height: 35px;
      color: #000000;
      margin-right: 0;
      //border-radius: 20px;
    }
    .ant-input-wrapper.ant-input-group{
      .ant-input{
        border-right: 0;
        border-top-right-radius: 0;
        border-bottom-right-radius: 0;
      }
      .ant-input-group-addon{
        background: #fff;
        font-size: 14px;
        font-weight: 400;
        color: #5E7A92;
        line-height: 20px;
        border-top-right-radius: 20px;
        border-bottom-right-radius: 20px;
      }
    }
  }
  .submit-button{
    margin-top: 5%;
    width: 100%;
    // padding-left: 500px;
    text-align: center;
  }
}
/deep/ .ant-form .list .ant-form-item-label label{
  font-weight: 600;
}

</style>
